module.exports = __webpack_public_path__ + "static/media/trip_of_a_lifetime.9ef66abe.svg";